import { GET_USER_FROM_SESSION } from 'actions/Types';

function isLoggedOut(state = false, action) {
  if (action.type === `${GET_USER_FROM_SESSION}_FAILURE`) {
    return true;
  }

  return state;
}

export default isLoggedOut;
